import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import LoginAlert from '../components/LoginAlert';
import './Login.css';

const username = process.env.REACT_APP_USERNAME;
const password = process.env.REACT_APP_PASSWORD;

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [error, setError] = useState('');

  const handleLogin = async (credentials) => {
    try {
      // Check for specific credentials
      if (credentials.username === username && credentials.password === password) {
        // Store user session
        localStorage.setItem('isAuthenticated', 'true');
        localStorage.setItem('username', credentials.username);
        // Redirect to the voucher page or the page they were trying to access
        const from = location.state?.from?.pathname || '/voucher';
        navigate(from);
      } else {
        setError('Invalid username or password');
      }
    } catch (err) {
      setError('Login failed. Please try again.');
    }
  };

  const handleClose = () => {
    navigate('/');
  };

  return (
    <div className="login-page">
      <LoginAlert onLogin={handleLogin} onClose={handleClose} />
      {error && <div className="error-message">{error}</div>}
    </div>
  );
};

export default Login; 